import * as React from 'react';
import { IAbo } from '../../api/model/IAbo';
import { PrimaryButton } from "@fluentui/react";
import Card from '@material-ui/core/Card';
import CardActions from '@material-ui/core/CardActions';
import CardContent from '@material-ui/core/CardContent';
import Divider from '@material-ui/core/Divider';
import { mergeStyleSets } from '@fluentui/merge-styles/lib/mergeStyleSets';
import { Text } from '@fluentui/react-components';
import { webDarkTheme, webLightTheme } from "@fluentui/react-components";
import { Spinner } from '@fluentui/react/lib/Spinner';
import { useGlobalState } from '../../service/globalState.service';


const cardPadding = { padding: '3px 6px' };

const styles = mergeStyleSets({
  header: {
    fontWeight: 600
  }
});

interface LinkCardProps {
  task: IAbo;
  isLinked: boolean;
  disabled?: boolean;
  onClick: () => Promise<void>;
}

export const LinkCard: React.FC<LinkCardProps> = ({ task, isLinked, onClick, disabled }) => {
  const [{ darkTheme }] = useGlobalState('settings');
  const [spinner, showSpinner] = React.useState(false);
  const theme = darkTheme ? webDarkTheme : webLightTheme;
  const cardStyle = darkTheme ? {
    backgroundColor: theme.colorNeutralBackground1,
    borderColor: theme.colorNeutralStroke1,
  } : {};
  const dividerStyle = darkTheme ? { backgroundColor: theme.colorNeutralStroke2 } : {};
  // AssignmentWork is in minutes, convert to hours
  const hours = Math.round(task.AssignmentWork / 60);
  const startDate = new Date(task.StartDate).toLocaleDateString('default', { month: 'short', day: 'numeric', year: 'numeric'})
  const endDate = new Date(task.EndDate).toLocaleDateString('default', { month: 'short', day: 'numeric', year: 'numeric' })
  const dateRange = startDate == endDate ? 
    startDate : 
    new Date(task.StartDate).toLocaleDateString('default', { month: 'short', day: 'numeric'}) + ' - ' + endDate;

  const click = async () => {
    showSpinner(true)

    try {
      await onClick();
    } catch (error) {
      console.error('Failed to toggle link status:', error);
    }

    showSpinner(false);
  }

  return (
    <Card variant='outlined' style={cardStyle}>
        <CardContent style={cardPadding}>
            <Text size={400} weight="semibold" style={{ color: theme.colorNeutralForeground3 }} className={styles.header}>
            {task.TaskName}
          </Text><br/>
          <Text size={300} weight="semibold" style={{ color: theme.colorNeutralForeground3 }} >
            {task.ProjectName}
          </Text>
        </CardContent>
        <Divider style={dividerStyle} />
        <CardActions style={{
          ...cardPadding,
          justifyContent: 'space-between'
        }}>
          <div style={{ display: 'flex', justifyContent: 'space-between' , width: '100%'}}>
            <Text size={300} style={{ color: theme.colorNeutralForeground3 }}>
              Work: {hours}h
            </Text>
            <Text size={300} style={{ color: theme.colorNeutralForeground3 }}>
              {dateRange}
            </Text>
          </div>
          {spinner ?
            <Spinner /> :
            <PrimaryButton
              text={isLinked ? 'Unlink' : 'Link'}
              disabled={disabled}
              iconProps={{ iconName: isLinked ? 'RemoveLink' : 'Link' }}
              primary={!isLinked}
              onClick={click}
              styles={{
                root: {
                  height: 28,
                  padding: '0 12px',
                  fontSize: 12,
                },
                icon: {
                  fontSize: 14,
                },
              }}
            />
          }
        </CardActions>
    </Card >
  )
}